"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGraph = void 0;
const react_d3_graph_1 = require("react-d3-graph");
const react_1 = __importStar(require("react"));
const config_1 = __importDefault(require("./config"));
const helper_1 = require("./helper");
const popup_1 = require("@components/popup");
const show_link_data_1 = require("@components/show-link-data");
const CustomGraph = (props) => {
    const { tabContent, wallet, directTransactions } = props;
    const [selectedLinks, setSelectedLinks] = (0, react_1.useState)();
    const closeLinkData = (0, react_1.useCallback)(() => {
        setSelectedLinks(undefined);
    }, []);
    const findLinkClicked = (source, target) => {
        let arr = [];
        tabContent.map((item) => {
            if (item.toAddress === target || item.fromAddress === target) {
                arr.push(item);
            }
        });
        setSelectedLinks(arr);
    };
    const data = (0, helper_1.getGraphData)(tabContent, wallet, directTransactions);
    return (react_1.default.createElement("div", { className: "c-graph" },
        react_1.default.createElement(react_d3_graph_1.Graph, { id: "graph", config: config_1.default, data: data, onClickLink: findLinkClicked }),
        react_1.default.createElement(popup_1.Popup, { isOpened: Boolean(selectedLinks), onClose: closeLinkData }, selectedLinks && react_1.default.createElement(show_link_data_1.ShowLinkData, { links: selectedLinks, onClose: closeLinkData }))));
};
exports.CustomGraph = CustomGraph;
